var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vi-button',{class:_vm.name,attrs:{"data-testid":"custom-create-button-dEYsX5","icon":"vi-icon2-add-small","type":"text"},on:{"click":_vm.onAdd}},[_vm._v("\n   "+_vm._s(_vm.$t('module_creative_identity_add_new_custom_action_text'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }